
  export enum IconSize {
    SMALL = 'smal',
    EXTRA_SMALL = 'extra_smal',
    MEDIUM = 'medium',
    DEMI = 'demi',
    BIG = 'big',
    BIGGER='bigger'    
  }
  